<template>
  <div
    id="chatbot"
    class="chatbot-main"
    :class="collapsedChat ? 'collapsed' : ''"
  >
    <button id="chatbot-button" @click="collapsedChat = !collapsedChat">
      <i :class="collapsedChat == true ? 'icofont-chat' : 'icofont-close'"></i>
    </button>
    <div class="chatbot-head">
      <span>Chaic</span>
      <i
        class="icofont-refresh"
        v-if="collapsedChat == false"
        @click="messages = []"
      ></i>
    </div>
    <div class="chatbot-body" ref="scrollChatBody">
      <div
        class="chatbot-body-message"
        v-for="(item, index) in messages"
        :key="index"
      >
        <!-- mensagem API -->
        <div class="chatbot-body-message-api" v-if="item.author === 'api'">
          <div v-html="item.text"></div>
          <div v-if="item.enableLike" class="chatbot-like">
            <div class="radio-button">
              <input
                type="radio"
                :value="['like', item]"
                :id="'radio-button-' + index + '-like'"
                v-model="selectedRadio"
              />
              <label :for="'radio-button-' + index + '-like'">
                <i class="icofont-like like" :class="item.classLike"></i>
              </label>
            </div>
            <div class="radio-button">
              <input
                type="radio"
                :value="['deslike', item]"
                :id="'radio-button-' + index + '-deslike'"
                v-model="selectedRadio"
              />
              <label :for="'radio-button-' + index + '-deslike'">
                <i class="icofont-like deslike" :class="item.classDeslike"></i>
              </label>
            </div>
          </div>
        </div>
        <!-- mensagem Client -->
        <span style="flex-grow: 1" v-if="item.author === 'client'"></span>
        <div
          class="chatbot-body-message-client"
          v-if="item.author === 'client'"
        >
          {{ item.text }}
        </div>
        <!-- error -->
        <div
          class="chatbot-body-message-error"
          v-if="item.author === 'error' && item.active == true"
        >
          <i class="icofont-robot"></i> {{ item.text }}
        </div>
      </div>
      <div class="chatbot-body-message"></div>
    </div>
    <div class="line"></div>
    <div
      class="input-div"
      :class="disabledInputText == true ? 'input-div-disabled' : ''"
    >
      <input
        v-on:keyup.enter="send()"
        class="input-message"
        name="message"
        type="text"
        id="message"
        placeholder="Escreva sua mensagem ..."
        v-model="messageClient"
        :disabled="disabledInputText"
        required
      />
      <button
        class="input-send"
        @click="send()"
        :disabled="messageClient.trim().length == 0"
      >
        <svg style="width: 24px; height: 24px">
          <path d="M2,21L23,12L2,3V10L17,12L2,14V21Z" />
        </svg>
      </button>
    </div>
    <b-modal
      id="modal-prevent-closing"
      ref="modal"
      title="Feedback adicional"
      v-model="modalRespostaEsperada"
      centered
      hide-footer
      size="lg"
    >
      <template #modal-title>
        <i class="icofont-like deslike"></i>
      </template>
      <form ref="form" @submit.stop.prevent="handleDeslike">
        <p>
          Por favor, ajude-me a melhorar. Me envia a resposta que você estava
          esperando.
        </p>
        <b-form-group
          label=""
          label-for="text-input"
          invalid-feedback="Campo obrigatório"
        >
          <b-form-textarea
            id="text-input"
            v-model="respostaEsperada"
            rows="10"
            required
          ></b-form-textarea>
        </b-form-group>
        <button
          type="submit"
          class="btn btn-default float-right"
          style="color: #fff"
        >
          Enviar
          <b-spinner
            small
            label="Small Spinner"
            variant="white"
            v-if="loadingBtnModal"
          ></b-spinner>
        </button>
      </form>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios'
import { marked } from 'marked'

export default {
  name: 'Chatbot',
  data() {
    return {
      collapsedChat: true,
      messages: [
        {
          text: `
            <i class="icofont-simple-smile"></i> Olá, seja bem-vind@! <br><br>

            Meu nome é <b>Chaic</b>, sou especialista na metotologia eSUS Feedback com foco em Monitoramento, Avaliação e Busca Ativa na APS. Vou te proporcionar uma experiência eficiente ao responder suas dúvidas. <br><br>

            <b>Como posso te ajudar hoje? </b>
          `,
          author: 'api',
          enableLike: false,
        },
      ],
      messageClient: '',
      disabledInputText: false,
      lastMessageApi: '',
      modalRespostaEsperada: false,
      respostaEsperada: '',
      itemParaRespostaEsperada: '',
      nameState: null,
      loadingBtnModal: false,
      selectedRadio: false,
    }
  },
  watch: {
    disabledInputText(val) {
      if (val == false) {
        const chatbotBody = this.$refs.scrollChatBody
        this.$nextTick(() => {
          chatbotBody.scrollTop = chatbotBody.scrollHeight + 100
        })
      }
    },
    selectedRadio(val) {
      if (val[0] == 'like') {
        val[1].classDeslike = ''
        val[1].classLike = 'paint-like'
        this.like(val[1].id)
      } else {
        val[1].classLike = ''
        val[1].classDeslike = 'paint-deslike'
        this.deslike(val[1])
      }
    },
  },
  methods: {
    async send() {
      if (this.messageClient.trim().length == 0) {
        return
      }

      const text = this.messageClient
      this.messageClient = ''

      this.messages.push({
        text: text,
        author: 'client',
      })
      const chatbotBody = this.$refs.scrollChatBody
      this.$nextTick(() => {
        chatbotBody.scrollTop = chatbotBody.scrollHeight + 100
      })
      try {
        this.disabledInputText = true
        this.messages.push({
          text: `
            <div class="chatbot-loading">
              <i class="icofont-robot"></i>
              <div class="chatbot-loading-icons">
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          `,
          author: 'api',
          enableLike: false,
        })

        const response = await axios.post(
          'https://api.gptbase.ai/v1/question/748f42a7-eb59-4cb8-b4a7-3842cbffae73',
          {
            question: text,
          }
        )
        if (response) {
          // salva a mensagem no banco
          const response2 = await this.$apiPublic.post('/chatbot/save', {
            pergunta: text,
            resposta_ia: response.data.answer,
          })

          // adiciona a mensagem na posição do loading
          this.messages[this.messages.length - 1] = {
            text: marked(response.data.answer),
            author: 'api',
            enableLike: true,
            id: response2.data.id,
            classLike: '',
            classDeslike: '',
          }
          this.$nextTick(() => {
            chatbotBody.scrollTop = chatbotBody.scrollHeight
          })
        }
      } catch (error) {
        console.log(error)
        switch (error.response.status) {
          case 524:
            this.messages.push({
              active: true,
              text: 'Ops... Aconteceu algo inesperado. Serviço indisponível no momento.',
              author: 'error',
            })
            break
          default:
            this.messages.push({
              active: true,
              text: 'Ops... Aconteceu algo inesperado. Serviço indisponível no momento.',
              author: 'error',
            })
            break
        }
      } finally {
        this.disabledInputText = false
      }
    },

    async like(id) {
      try {
        const response = await this.$apiPublic.post('/chatbot/like', {
          likes: 1,
          id: id,
          resposta_esperada: '',
        })
        if (response.data.error == false) {
          const resposta = this.messages.find((el) => el.id === id)
          if (resposta != undefined) {
            resposta.classLike = 'paint-like'
          }
        }
        console.log(this.messages)
      } catch (error) {
        console.log(error)
      }
    },

    async deslike(item) {
      this.modalRespostaEsperada = true
      this.itemParaRespostaEsperada = item
    },

    checkFormValidity() {
      const valid = this.$refs.form.checkValidity()
      this.nameState = valid
      return valid
    },

    async handleDeslike() {
      try {
        // Exit when the form isn't valid
        if (!this.checkFormValidity()) {
          return
        }
        this.loadingBtnModal = true
        const response = await this.$apiPublic.post('/chatbot/like', {
          likes: 0,
          id: this.itemParaRespostaEsperada.id,
          resposta_esperada: this.respostaEsperada,
        })
        if (response.data.error == false) {
          this.modalRespostaEsperada = false
          this.$toast.success('Obrigado! Feedback enviado com sucesso!', '', {
            position: 'topRight',
          })
          const resposta = this.messages.find(
            (el) => el.id === this.itemParaRespostaEsperada.id
          )
          if (resposta != undefined) {
            resposta.classLike = 'paint-deslike'
          }
        }
      } catch (error) {
        console.log(error)
        this.$toast.error(
          'Erro ao enviar feedback! Por favor, tente novamente mais tarde.',
          '',
          {
            position: 'topRight',
          }
        )
      } finally {
        this.loadingBtnModal = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@media (min-width: 450px) {
  .chatbot-main {
    width: 96%;
    max-width: 500px;
    height: calc(100% - 32px) !important;
    border-radius: 8px !important;
    max-height: 630px;
    margin: 16px !important;
  }
}

.collapsed {
  width: 58px !important;
  height: 58px !important;
  border-radius: 36px !important;
  margin: 16px !important;
  #chatbot-button {
    i {
      font-size: 25px !important;
    }
  }
}

.chatbot-main {
  background: white;
  color: white;
  width: 100%;
  height: 100%;
  margin: 0px;
  border-radius: 0px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  right: 0;
  bottom: 0;
  position: fixed;
  transition: all 0.5s;
  box-shadow: 0 0 40px 0 rgb(82 63 105 / 0%);
  z-index: 999;
}

#chatbot-button {
  position: absolute;
  right: 0;
  border: none;
  height: 58px;
  width: 58px;
  background: #0d98bb;
  color: white;
  i {
    font-size: 25px !important;
  }
}

.line {
  height: 1px;
  background-color: #0d98bb;
  width: 100%;
  opacity: 0.2;
}

.chatbot-head {
  background-color: #0d98bb;
  font-size: large;
  font-weight: bold;
  display: flex;
  height: 58px;

  > div {
    height: 58px;
    width: 58px;
    display: flex;
    margin-left: 8px;
  }

  svg {
    height: 24px;
    margin: auto;
  }

  span {
    margin: auto auto auto 22px;
    height: 58px;
    display: flex;
    align-items: center;
    font-size: 22px;
  }

  i {
    position: absolute;
    right: 12%;
    top: 2.6%;
    color: #fff;
    cursor: pointer;
    font-size: 25px;
    @media (max-width: 656px) {
      top: 1.8%;
      right: 15%;
    }
  }
}

.chatbot-body {
  flex-grow: 1;
  overflow: auto;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
}

.input-message {
  padding: 8px 48px 8px 16px;
  flex-grow: 1;
  border: none;
}

.input-message:focus {
  outline: none;
}

.input-div {
  height: 48px;
  display: flex;
}

.input-div-disabled {
  background: rgba(0, 0, 0, 0.05);
}

.input-send {
  background: transparent;
  width: 48px;
  height: 48px;
  right: 0%;
  border: none;
  cursor: pointer;
}

.input-send:hover {
  background: lavender;
}

.input-send svg {
  fill: #000;
  margin: 11px 8px;
}

.chatbot-body-message {
  display: flex;
}

.chatbot-body-message-client {
  margin: 8px 16px 8px 64px;
  padding: 8px 16px;
  animation-name: fadeIn;
  animation-iteration-count: 1;
  animation-timing-function: ease-in;
  animation-duration: 100ms;
  color: black;
  border-radius: 8px 8px 2px 8px;
  background-color: #d4edda;
}

.chatbot-body-message-api {
  margin: 8px 64px 8px 16px;
  padding: 8px 16px;
  animation-name: fadeIn;
  animation-iteration-count: 1;
  animation-timing-function: ease-in;
  animation-duration: 100ms;
  color: black;
  border-radius: 8px 8px 8px 2px;
  background-color: #cce5ff;
  .radio-button {
    display: inline-block;
  }

  input[type='radio'] {
    display: none;
  }
}

.chatbot-body-message-loading {
  margin: 8px 64px 8px 16px;
  padding: 8px 16px;
  animation-name: fadeIn;
  animation-iteration-count: 1;
  animation-timing-function: ease-in;
  animation-duration: 100ms;
  color: black;
  border-radius: 8px 8px 8px 2px;
  background-color: #cce5ff;
}

.chatbot-body-message-error {
  margin: 8px 64px 8px 16px;
  padding: 8px 16px;
  animation-name: fadeIn;
  animation-iteration-count: 1;
  animation-timing-function: ease-in;
  animation-duration: 100ms;
  color: black;
  border-radius: 8px 8px 8px 2px;
  background-color: #f8d7da;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
</style>

<style lang="scss">
.chatbot-loading {
  display: flex;
  gap: 6px;
  .chatbot-loading-icons {
    display: flex;
    gap: 6px;
    div {
      width: 5px;
      height: 5px;
      background: #000;
      border-radius: 50%;
      animation: cycle 1s ease-in-out infinite;
    }

    div:nth-child(1) {
      animation-delay: 0;
    }

    div:nth-child(2) {
      animation-delay: 0.2s;
    }

    div:nth-child(3) {
      animation-delay: 0.4s;
    }

    @keyframes cycle {
      0% {
        transform: translateY(0);
      }

      50% {
        transform: translateY(0.6rem);
      }

      100% {
        transform: translateY(0);
      }
    }
  }
}

.chatbot-like {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  i {
    cursor: pointer;
    &:hover {
      color: #ccc;
    }
  }
  .like {
    &.paint-like {
      color: green;
    }
    &:hover {
      color: green;
    }
  }
  .deslike {
    display: inline-block;
    transform: rotate(180deg);
    &.paint-deslike {
      color: red;
    }
    &:hover {
      color: red;
    }
  }
}

#modal-prevent-closing {
  .deslike {
    transform: rotate(180deg);
    background: #ffb3b3;
    padding: 8px;
    border-radius: 36px;
    text-align: center;
    color: red;
    margin-right: 10px;
    display: inline-block;
  }
}
</style>
